import { render, staticRenderFns } from "./big-preview.vue?vue&type=template&id=17a18324&scoped=true&"
import script from "./big-preview.vue?vue&type=script&lang=js&"
export * from "./big-preview.vue?vue&type=script&lang=js&"
import style0 from "./big-preview.vue?vue&type=style&index=0&id=17a18324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a18324",
  null
  
)

export default component.exports